import React from 'react';
import { useNewsletterInputEmail } from '../hooks/useNewsletterInputEmail';

const NewsletterInputEmailContainer = () => {
	const { blockClass, placeholderText, inputLabel, componentId } = useNewsletterInputEmail();
	const labelClasses = 'vtex-input__label db mb3 w-100 c-on-base t-small';

	const renderClass = () => {
		return (
			blockClass && `emailInputContainer--${blockClass} vtex-store-newsletter-1-x-emailInputContainer--${blockClass}`
		);
	};

	return (
		<div
			data-selection={componentId}
			className={`emailInputContainer ${renderClass()} vtex-store-newsletter-1-x-emailInputContainer`}
		>
			{inputLabel && <span className={labelClasses}>{inputLabel}</span>}
			<label className="vtex-input w-100">
				<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
					<input
						className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
						name="newsletter"
						placeholder={placeholderText || 'Endereço de email'}
						type="email"
						id="newsletter-input-email"
					/>
				</div>
			</label>
		</div>
	);
};

export default NewsletterInputEmailContainer;
